import React, { FC } from "react";
import { Image } from "cloudinary-react";
import mobileMoney from "../../assets/images/mobile-money.svg";
import { motion } from "framer-motion";

export const PaymentTypes: FC<{}> = () => {
  return (
    <motion.section id="payments" layout className="payment-section">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-6 d-none d-lg-block">
            <Image publicId="momoPhone_arcmwo" />
          </div>
          <div className="col-12 col-lg-6">
            <div className="heading">
              <h2>
                Payments We <span>Accept.</span>
              </h2>
            </div>
            <div className="content">
              <div>
                <img src={mobileMoney} alt="" />
              </div>
              <div className="caption">
                <h2>Mobile Money</h2>
                <p>
                  Buy and Sell on Speednance using Mobile Money. Pay and get
                  paid through mobile money on any network. Mobile money
                  payments are available 24/7.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};
